import React from "react";
import { FieldError } from "../../common/fields";
import { isUserB2B } from "../../../utils";
import {Button, ButtonGroup, Typography} from "@one-thd/sui-atomic-components";
import { selectAutomationIdBasedOnComponent } from "../../../utils/automationIds";

const OtpInfoView = (props) => {
  const {
    emailEditContext = {},
    enablePhoneVerifyButton,
    onClickCantAccess,
    errorState,
    submitButtonAction,
    cancelButtonAction,
    origin
  } = props;

  const { email } = emailEditContext || {};

  const otpChannel = origin === "phoneEdit" ? "phone number" : "email address";
  let mainText = `Before you change your ${otpChannel} we need to confirm who you are by sending a code to`;

  const selectedFlow = (origin==="phoneEdit") ? "phone" : "email";

  return (
    <>
      <Typography>
        {mainText}
      </Typography>
    <p className="sui-font-bold sui-text-base sui-tracking-normal sui-normal-case sui-line-clamp-unset sui-break-all">
      {email}
    </p>
    {!!errorState.length &&
        <div className="otp-options-view-error col__12-12 no-padding-sides form-input--error">
          <FieldError name="otp" errors={errorState}/>
        </div>}
    {enablePhoneVerifyButton && !isUserB2B() &&
          <button type="button" onClick={onClickCantAccess}
            className="otp-info-view-phone-verify-button u__default-link sui-my-4 sui-pt-4">
              I don&apos;t have access to this account
            </button>}
      <ButtonGroup fullWidth orientation='vertical'>
        <Button variant="primary"
                data-automation-id={selectAutomationIdBasedOnComponent(selectedFlow, "sendCodeIdentity")}
                onClick={submitButtonAction}>
            Send Code
        </Button>
        <Button data-automation-id={selectAutomationIdBasedOnComponent(selectedFlow, "cancel")}
                onClick={cancelButtonAction}>
          Cancel
        </Button>
      </ButtonGroup>
    </>
  );
};

export default OtpInfoView;
